import axios from 'axios';
import { Revision, MetaSiteData } from '../types';

const axiosInstance = axios.create({
  withCredentials: true,
});

function migrateOldAPIToNew(revision: Revision) {
  return {
    ...revision,
    isPublished: revision.published,
    isStarred: revision.flagged,
    isReleaseCandidate: revision.releaseCandidate,
    title: revision.comment || revision.dateCreated,
  };
}

export async function fetchRevisions(
  queryWithSiteIdAndMetaSiteId: string,
): Promise<Revision[] | Error> {
  try {
    const response = await axiosInstance.get(
      `/_api/site-revisions-server/revisions/${queryWithSiteIdAndMetaSiteId}`,
    );

    return response.data.map((revision: Revision) =>
      migrateOldAPIToNew(revision),
    ) as Revision[];
  } catch (e) {
    return new Error('Failed to load revisions');
  }
}

export async function fetchMetaSiteData(
  metaSiteId: string,
): Promise<MetaSiteData | Error> {
  try {
    const response = await axiosInstance.get(
      `/_api/site-revisions-server/revisions/${metaSiteId}`,
    );
    return response.data as MetaSiteData;
  } catch (e) {
    return new Error('Failed to load revisions');
  }
}

export async function restoreRevision(siteId: string, revisionId: string) {
  try {
    await axiosInstance.post(
      `/_api/site-revisions-server/revisions/restore/${siteId}/${revisionId}`,
    );
  } catch (e) {
    return new Error('Failed to restore revisions');
  }
}

export async function starRevision(siteId: string, revision: Revision) {
  try {
    await axiosInstance.post(
      `/_api/site-revisions-server/revisions/star/${siteId}/${revision.revision}-${revision.editorType}`,
    );
  } catch (e) {}
}

export async function unStarRevision(siteId: string, revision: Revision) {
  try {
    await axiosInstance.post(
      `/_api/site-revisions-server/revisions/unstar/${siteId}/${revision.revision}-${revision.editorType}`,
    );
  } catch (e) {}
}

export async function renameRevision(
  siteId: string,
  revision: Revision,
  newName: string,
) {
  try {
    await axiosInstance.post(
      `/_api/site-revisions-server/revisions/rename/${siteId}/${revision.revision}-${revision.editorType}`,
      { name: newName },
    );
  } catch (e) {}
}
